import React from 'react';
import { ReactComponent as InfoIcon } from '@/img/icon-info.svg';
import { ReactComponent as LocationIcon } from '@/img/icon-location.svg';
import { ReactComponent as DocIcon } from '@/img/icon-doc.svg';
import { ReactComponent as LinkIcon } from '@/img/icon-link.svg';
import { ReactComponent as DownloadIcon } from '@/img/icon-download.svg';
import { ReactComponent as CalendarIcon } from '@/img/icon-calendar.svg';
import { ReactComponent as MessageIcon } from '@/img/icon-message.svg';
import './UIFieldInfo.scss';

export type UIFieldInfoIconType =
  | 'info'
  | 'location'
  | 'doc'
  | 'link'
  | 'download'
  | 'calendar'
  | 'message';

export interface UIFieldInfoProps {
  /**
   * Текст поля
   */
  text: string;

  /**
   * Тип іконки (опціонально)
   */
  iconType?: UIFieldInfoIconType;

  /**
   * Кастомна іконка (має пріоритет над iconType)
   */
  icon?: React.ReactNode;

  /**
   * Чи є текст посиланням
   */
  isLink?: boolean;

  /**
   * Обробник кліку
   */
  onClick?: () => void;

  /**
   * Додатковий CSS клас
   */
  className?: string;
}

// Мапа іконок
const iconMap: Record<UIFieldInfoIconType, React.ComponentType> = {
  info: InfoIcon,
  location: LocationIcon,
  doc: DocIcon,
  link: LinkIcon,
  download: DownloadIcon,
  calendar: CalendarIcon,
  message: MessageIcon,
};

// Мокова іконка
const MockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle
      cx="8"
      cy="8"
      r="6"
      stroke="currentColor"
      strokeWidth="1"
    />
  </svg>
);

const baseClass = 'UIFieldInfo';

const UIFieldInfo: React.FC<UIFieldInfoProps> = ({
                                                   text,
                                                   iconType,
                                                   icon,
                                                   isLink = false,
                                                   onClick,
                                                   className = ''
                                                 }) => {
  const hasIcon = icon || iconType;

  const fieldClasses = [
    baseClass,
    hasIcon && `${baseClass}--with-icon`,
    (isLink || onClick) && `${baseClass}--clickable`,
    className
  ].filter(Boolean).join(' ');

  const renderIcon = () => {
    if (icon) {
      return icon;
    }

    if (iconType) {
      const IconComponent = iconMap[iconType];
      return IconComponent ? <IconComponent /> : <MockIcon />;
    }

    return null;
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={fieldClasses} onClick={handleClick}>
      {hasIcon && (
        <span className={`${baseClass}__icon`}>
          {renderIcon()}
        </span>
      )}
      <span className={`${baseClass}__text`}>
        {text}
      </span>
    </div>
  );
};

export default UIFieldInfo;